import { UPDATEGROUP_FAIL, UPDATEGROUP_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const updateGroupMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEGROUP_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEGROUP_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default updateGroupMemberReducer;
